import { StyleSheet } from "react-native";
import { theme } from "../../../../theme";
export const styles = StyleSheet.create({
    default: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    label: {
        paddingRight: theme.spacing.xsmall,
        ...theme.fontDefaults.small,
    },
});
//# sourceMappingURL=InputToggle.styles.js.map